import styled from 'styled-components'


export const DivCardType = styled.div`
margin: 0 auto;
padding-bottom:30px
margin-block-end:-60px;
margin-block-start:-80px

  @media (min-width: 575px) {
    max-width: 540px;
    margin-inline: auto;
    padding-bottom:30px
  }

  @media (min-width: 768px) {
    max-width: 740px;
    padding-bottom:30px
  };
  
  @media (min-width: 992px) {
    max-width: 1300px;
    padding-bottom:30px
  };
  
  @media (min-width: 1200px)
      max-width: 1180px;
      padding-bottom:30px
  }

`

export const CardType = styled.div`
--title-color: var(--space-cadet-2);
--meta-color: var(--old-lavender);
--icon-color: var(--ultramarine-blue);
--icon-bg: var(--white);

background-color: var(--cultured-1);
padding: 10px;
display: flex;
align-items: center;
gap: 20px;
border-radius: var(--radius-6);
width: 95%;
margin: 0 auto;
transition: var(--transition-1);

&:hover, &:focus  {
  --title-color: var(--white);
  --meta-color: var(--white);
  --icon-color: var(--white);
  --icon-bg: var(--white_10);

  background-color: var(--ultramarine-blue)
}

@media (min-width: 992px) {
  height: 100%;
  width: 90%
}
`
export const CardIconType = styled.div `
color: var(--icon-color);
font-size: 30px;
min-width: 60px;
place-items: center;
border-radius: var(--radius-4);
transition: var(--transition-1);
}
`

export const H3CardType = styled.h3`
display:flex;
text-align:center;
color: var(--title-color);
font-Size:1.8rem;
`




